/**
 * A timeout must stay above the backend's ceiling for the route: giving up first aborts work that
 * would have succeeded and, on a write, leaves the caller unable to tell whether it applied.
 */

/** Ceiling for any call the user waits on. */
export const TIMEOUT_DEFAULT_MS = 120_000

/** Transfers, long-running jobs, and third-party endpoints, where a deadline only breaks work that is still running. */
export const TIMEOUT_NONE = 0
